// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__bHUOT","page":"styles_page__VnR0p"};